import { Reveal } from "./Reveal";
import { Instagram, Facebook } from "lucide-react";
import { SOCIALS, GoogleIcon } from "./Socials";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-heirloom-cream py-24 md:py-28">
      <div className="max-w-[1300px] mx-auto px-6">
        <Reveal className="text-center mb-12">
          <span className="gold-rule overline text-heirloom-maroon">Visit Us</span>
          <h2 className="font-display text-4xl md:text-5xl text-heirloom-obsidian mt-4">Our Studio in <span className="text-heirloom-maroon italic">Indore</span></h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch">
          <div className="lg:col-span-2 space-y-5">
            <div className="bg-heirloom-bone rounded-2xl border border-heirloom-line p-7">
              <div className="overline text-[0.6rem] text-heirloom-maroon mb-2">Address</div>
              <p className="text-heirloom-obsidian/75 leading-relaxed">
                LG-17, Orbit Mall, A.B. Road, Vijay Nagar, Indore, Madhya Pradesh 452010
                <span className="block text-sm text-heirloom-obsidian/50 mt-2">Opposite Alba Restaurant, near Raghunath Prasad Petrol Pump</span>
              </p>
            </div>
            <div className="bg-heirloom-bone rounded-2xl border border-heirloom-line p-7">
              <div className="overline text-[0.6rem] text-heirloom-maroon mb-2">Call</div>
              <a href="tel:+918770847087" data-testid="contact-phone-1" className="block text-heirloom-obsidian/80 hover:text-heirloom-maroon transition-colors">+91 87708 47087</a>
              <a href="tel:+919320018909" data-testid="contact-phone-2" className="block text-heirloom-obsidian/80 hover:text-heirloom-maroon transition-colors">+91 93200 18909</a>
              <a href="tel:+918085718909" data-testid="contact-phone-3" className="block text-heirloom-obsidian/80 hover:text-heirloom-maroon transition-colors">+91 80857 18909</a>
            </div>
            <div className="bg-heirloom-bone rounded-2xl border border-heirloom-line p-7">
              <div className="overline text-[0.6rem] text-heirloom-maroon mb-2">Email</div>
              <a href="mailto:arihanteventsindore@gmail.com" data-testid="contact-email" className="block text-heirloom-obsidian/80 hover:text-heirloom-maroon transition-colors break-all">arihanteventsindore@gmail.com</a>
            </div>
            <div className="bg-heirloom-bone rounded-2xl border border-heirloom-line p-7">
              <div className="overline text-[0.6rem] text-heirloom-maroon mb-3">Follow Us</div>
              <div className="flex items-center gap-4">
                <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram" aria-label="Instagram" className="h-11 w-11 rounded-full bg-heirloom-maroon/10 text-heirloom-maroon flex items-center justify-center hover:bg-heirloom-maroon hover:text-heirloom-bone transition-colors">
                  <Instagram size={19} />
                </a>
                <a href={SOCIALS.facebook} target="_blank" rel="noreferrer" data-testid="contact-facebook" aria-label="Facebook" className="h-11 w-11 rounded-full bg-heirloom-maroon/10 text-heirloom-maroon flex items-center justify-center hover:bg-heirloom-maroon hover:text-heirloom-bone transition-colors">
                  <Facebook size={19} />
                </a>
                <a href={SOCIALS.google} target="_blank" rel="noreferrer" data-testid="contact-google" aria-label="Google" className="h-11 w-11 rounded-full bg-white border border-heirloom-line flex items-center justify-center hover:shadow-md transition-shadow">
                  <GoogleIcon size={20} />
                </a>
              </div>
            </div>
          </div>
          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="rounded-2xl overflow-hidden border border-heirloom-line h-[420px] lg:h-full">
              <iframe
                title="Arihant Events Location"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Orbit%20Mall%2C%20AB%20Road%2C%20Vijay%20Nagar%2C%20Indore&output=embed"
                className="w-full h-full"
                style={{ border: 0 }}
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
